import { render, staticRenderFns } from "./arrowOptionsPreview.vue?vue&type=template&id=8cfddaf4&scoped=true&lang=pug&"
import script from "./arrowOptionsPreview.vue?vue&type=script&lang=js&"
export * from "./arrowOptionsPreview.vue?vue&type=script&lang=js&"
import style0 from "./arrowOptionsPreview.vue?vue&type=style&index=0&id=8cfddaf4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfddaf4",
  null
  
)

export default component.exports